import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
import { Tab, Tabs, TabsProps } from '@mui/material';

export const ALL_OPTION = {
  name: 'All',
  value: 'all',
} as const;

export type DimensionTabsProps = {
  dimensionCounts: { [key in keyof typeof apiSlugToDimensionName]: number };
  allSubdimensionsCount: number;
  activeTab: string;
  onChange: TabsProps['onChange'];
};

/**
 * @deprecated Use DimensionChips instead
 */
export const DimensionTabs = (props: DimensionTabsProps) => {
  return (
    <Tabs
      value={props.activeTab}
      onChange={props.onChange}
      variant="scrollable"
    >
      <Tab
        label={`${ALL_OPTION.name} (${props.allSubdimensionsCount})`}
        value={ALL_OPTION.value}
      />
      {Object.entries(props.dimensionCounts).map(([dimension, count]) => (
        <Tab
          key={dimension}
          label={`${
            apiSlugToDimensionName[
              dimension as keyof typeof apiSlugToDimensionName
            ]
          } (${count})`}
          value={dimension}
        />
      ))}
    </Tabs>
  );
};
